import isEqual from 'lodash/isEqual';
import {
    CLASS_LIST,
    ALL_CLASSES_OPTION,
    GROUP_LIST,
    ALL_GROUPS_OPTION,
    STUDENT_LIST,
    ALL_STUDENTS_OPTION,
    REPORT_LIST,
    REPORT_OPTIONS,
    PARTICIPATION_OPTION,
    YEAR_GROUP_LIST,
    ALL_YEARS_OPTION,
    TEACHER_LIST,
    ALL_TEACHERS_OPTION,
    DATE_LIST
} from '../../filter-constants';
import {
    SET_DROPDOWN_DATA,
    UPDATE_DROPDOWN_DATA_ITEM
} from './dropdown-data-actions';
import DateParamHelper from '../../../../helpers/date-param-helper';

const initialDate = DateParamHelper.getInitialDate();

export const initialState = () => [
    {
        type: YEAR_GROUP_LIST,
        data: [ALL_YEARS_OPTION],
        selectedOption: ALL_YEARS_OPTION,
        disabled: false
    },
    {
        type: TEACHER_LIST,
        data: [ALL_TEACHERS_OPTION],
        selectedOption: ALL_TEACHERS_OPTION,
        disabled: false
    },
    {
        type: CLASS_LIST,
        data: [ALL_CLASSES_OPTION],
        selectedOption: ALL_CLASSES_OPTION,
        disabled: false
    },
    {
        type: GROUP_LIST,
        data: [ALL_GROUPS_OPTION],
        selectedOption: ALL_GROUPS_OPTION,
        disabled: true
    },
    {
        type: STUDENT_LIST,
        data: [ALL_STUDENTS_OPTION],
        selectedOption: ALL_STUDENTS_OPTION,
        disabled: true
    },
    {
        type: REPORT_LIST,
        data: REPORT_OPTIONS,
        selectedOption: PARTICIPATION_OPTION
    },
    // date is a bit different to the others and uses DatePicker rather than DropdownMenu component
    {
        type: DATE_LIST,
        data: null,
        selectedOption: initialDate
    }
];

/**
 * Dropdown Data Reducer
 *
 * @param {boolean} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {array} - filter dropdowns to display, with their selected option, data & disabled status
 */
export default function(state = initialState(), action) {
    if (!action) return state;

    switch (action.type) {
        case SET_DROPDOWN_DATA: {
            // only update the items which have actually changed
            const newState = action.payload.map((newItem) => {
                const prevItem = state.find(
                    (item) => item.type === newItem.type
                );
                if (!isEqual(newItem, prevItem)) {
                    return newItem;
                }
                return prevItem;
            });
            return newState;
        }

        case UPDATE_DROPDOWN_DATA_ITEM: {
            const newState = [...state];
            const itemIdx = newState.findIndex(
                (item) => item.type === action.payload.type
            );
            newState[itemIdx] = action.payload.item;
            return newState;
        }

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./components/report-filters/redux/dropdown-data/dropdown-data-reducer.js